import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import translationCN from '../../locales/zh-CN.json'
import translationEN from '../../locales/en-US.json'

export const messages = {
  'en-US': Object.assign({}, translationEN, enLocale),
  'zh-CN': Object.assign({}, translationCN, zhLocale)
}
